// HTML entities
export const SUP2 = String.fromCharCode(178);
export const SUP3 = String.fromCharCode(179);
export const NBSP = String.fromCharCode(160);
